import { createSlice } from "@reduxjs/toolkit";

const getAllClassWithSectionDetailsSlice = createSlice({
  name: "classsWithSectionsDetailsList",
  initialState: {
    classWithSectionsDetailsList : [],
    loading: false,
    error: null,
  },
  reducers: {
    getAllClassWithSectionDetailsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getAllClassWithSectionDetailsSuccess: (state, action) => {
      state.loading = false;
      state.classWithSectionsDetailsList = action.payload;
    },
    getAllClassWithSectionDetailsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearAllClassWithSectionDetails: (state) => {
      state.classWithSectionsDetailsList = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  getAllClassWithSectionDetailsRequest,
  getAllClassWithSectionDetailsSuccess,
  getAllClassWithSectionDetailsFailure,
  clearAllClassWithSectionDetails,
} = getAllClassWithSectionDetailsSlice.actions;

export default getAllClassWithSectionDetailsSlice.reducer;
